import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteGrupoUnidade() {
  return useMutation(
    (id: string) => {
      return http.delete(`/v1/grupo-unidade/${id}`);
    },
    { retry: false }
  );
}

export default useDeleteGrupoUnidade;
